<script setup lang="ts">
import type { Typography } from '@/types/Typography';

const {
  element = 'p',
  type = 'body-1',
  color = '-primary',
} = defineProps<{
  element?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';
  type?: Typography;
  color?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'fields'
    | 'border'
    | 'on-tertiary'
    | 'error'
    | 'black'
    | 'background'
    | 'primary-1'
    | 'primary-2'
    | 'primary-3'
    | '-primary'
    | '-secondary'
    | '-tertiary'
    | 'stroke';
}>();

const classes = computed(() => {
  // append your typography css here
  return [`font-${type}`, `text-${color}`];
});
</script>

<template>
  <component :is="element" data-testid="typography" :class="classes">
    <slot></slot>
  </component>
</template>

<style></style>
